/**
 * Default value of modal width
 *
 * IMPORTANT: Change of this value will impact TextFieldWithDropdownComponent in purchase and unique data modals.
 * If that happens, .vpfa-text-field-with-dropdown .ant-select-dropdown class properties (left and width) in file text-field-with-dropdown.component.scss must be adjusted accordingly
 */
export const DEFAULT_MODAL_WIDTH = '650px';
